// extracted by mini-css-extract-plugin
export default {"base":"vp_fWYT2","label":"vp_IT33S"};